import { getApolloClient } from '$apollo/util';
import type { CmsSymptomItem } from '$cms/types';
import { removeNullValues } from '$util/basic';
import type { AnyObject } from '$util/types';
import type {
  QueryFetchSymptomCollectionData,
  QueryFetchSymptomCollectionDataVariables,
} from './gql/queries/queryFetchSymptomCollectionData';
import { QUERY_FETCH_SYMPTOM_COLLECTION_DATA } from './gql/queries/queryFetchSymptomCollectionData';

type FetchSymptomCollectionDataContext = AnyObject & {
  readonly headers?: AnyObject;
};

export async function fetchSymptomCollectionData(
  { filter, segment, preview, limit = 20 }: QueryFetchSymptomCollectionDataVariables,
  context?: FetchSymptomCollectionDataContext
): Promise<CmsSymptomItem[]> {
  const apollo = getApolloClient();
  const { data } = await apollo.query<
    QueryFetchSymptomCollectionData,
    QueryFetchSymptomCollectionDataVariables
  >({
    query: QUERY_FETCH_SYMPTOM_COLLECTION_DATA,
    variables: {
      filter,
      segment,
      preview,
      limit,
    },
    context: {
      needsAuthentication: false,
      ...context,
    },
    fetchPolicy: 'no-cache',
  });

  return removeNullValues(data?.getCmsSymptoms) || [];
}
